module.exports = __webpack_public_path__ + "00_mole.1f63ce66.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/mom/layer2/00_mole.png
// module id = PUwW
// module chunks = 0